import { Link } from 'react-router-dom';
import { useRegulatoryAlerts } from '../../hooks/useRegulatoryAlerts.js';

function hoursUntil(isoString) {
  if (!isoString) return null;
  const diff = new Date(isoString) - Date.now();
  const hours = Math.floor(diff / 3600000);
  if (hours < 0) return `${Math.abs(hours)}h overdue`;
  if (hours < 24) return `${hours}h`;
  return `${Math.floor(hours / 24)}d`;
}

export default function GlobalRegulatoryAlertBanner({ state, session }) {
  const { urgentAlerts, hasActiveAlert, mostUrgentDeadline } = useRegulatoryAlerts(state, session);

  if (!hasActiveAlert) return null;

  const deadline = hoursUntil(mostUrgentDeadline);
  const isOverdue = mostUrgentDeadline && new Date(mostUrgentDeadline) < new Date();

  return (
    <>
      {/* Persistent viewport border — pointer-events: none so it never blocks interaction */}
      <div
        style={{
          position: 'fixed',
          inset: 0,
          border: '3px solid var(--danger)',
          pointerEvents: 'none',
          zIndex: 699,
        }}
      />
      {/* Sticky banner strip — pointer-events: auto to allow link click */}
      <div
        style={{
          background: 'var(--danger-bg)',
          borderBottom: '1px solid var(--danger)',
          padding: '8px 20px',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          pointerEvents: 'auto',
          flexWrap: 'wrap',
        }}
      >
        <span
          style={{
            fontSize: 11,
            fontFamily: 'var(--font-mono)',
            color: 'var(--danger)',
            fontWeight: 700,
            padding: '2px 8px',
            borderRadius: 4,
            border: '1px solid var(--danger)',
            background: 'var(--danger-bg)',
            flexShrink: 0,
          }}
        >
          REGULATORY
        </span>
        <span style={{ fontSize: 13, color: 'var(--fg)', fontWeight: 600 }}>
          Regulatory obligation active — {urgentAlerts.length} incident
          {urgentAlerts.length !== 1 ? 's' : ''} require action
        </span>
        {deadline && (
          <span
            style={{
              fontSize: 11,
              fontFamily: 'var(--font-mono)',
              color: isOverdue ? 'var(--danger)' : 'var(--warn)',
              padding: '2px 8px',
              borderRadius: 4,
              background: isOverdue ? 'var(--danger-bg)' : 'var(--warn-bg)',
              border: `1px solid ${isOverdue ? 'var(--danger)' : 'var(--warn)'}`,
              flexShrink: 0,
            }}
          >
            Next deadline: {deadline}
          </span>
        )}
        <Link
          to="/incidents?regulatory=active"
          style={{
            marginLeft: 'auto',
            fontSize: 12,
            color: 'var(--danger)',
            fontWeight: 600,
            textDecoration: 'none',
            flexShrink: 0,
          }}
        >
          View incidents →
        </Link>
      </div>
    </>
  );
}
